import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';
import ButtonWithLoader from 'components/ButtonWithLoader/ButtonWithLoader';
import styles from './BulkMessageModal.module.scss';

const BulkMessageModal = ({
  show,
  onHide,
  selectedApplicants,
  onSendMessage,
  sending,
}) => {
  const [message, setMessage] = useState('');

  const handleSend = () => {
    if (message.trim()) {
      onSendMessage(message);
      setMessage('');
    }
  };

  const handleClose = () => {
    setMessage('');
    onHide();
  };

  const applicantNames = selectedApplicants
    .map((applicant) => applicant.name)
    .join(', ');

  return (
    <Modal
      show={show}
      onHide={handleClose}
      bsSize="large"
      dialogClassName={styles.modal}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Send Message to {selectedApplicants.length} Applicant
          {selectedApplicants.length !== 1 ? 's' : ''}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={styles.recipientsSection}>
          <label className={styles.label}>Recipients:</label>
          <div className={styles.recipientsList}>{applicantNames}</div>
        </div>
        <div className={styles.messageSection}>
          <label className={styles.label} htmlFor="bulk-message">
            Message:
          </label>
          <textarea
            id="bulk-message"
            className={styles.textarea}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Type your message here..."
            rows={6}
            disabled={sending}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={handleClose}
          className={styles.button}
          disabled={sending}
        >
          Cancel
        </Button>
        <ButtonWithLoader
          bsStyle="primary"
          onClick={handleSend}
          disabled={!message.trim() || sending}
          loading={sending}
          className={styles.button}
          text={sending ? 'Sending...' : 'Send Message'}
        />
      </Modal.Footer>
    </Modal>
  );
};

BulkMessageModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  selectedApplicants: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
      userId: PropTypes.number,
    })
  ).isRequired,
  onSendMessage: PropTypes.func.isRequired,
  sending: PropTypes.bool,
};

BulkMessageModal.defaultProps = {
  sending: false,
};

export default BulkMessageModal;
